export var EnvironmentEnum;
(function (EnvironmentEnum) {
    EnvironmentEnum["Local"] = "local";
    EnvironmentEnum["Develop"] = "dev";
    EnvironmentEnum["Stage"] = "stage";
    EnvironmentEnum["Production"] = "prod";
})(EnvironmentEnum || (EnvironmentEnum = {}));
//# sourceMappingURL=env.constants.js.map